let conf = {
    server_address: "https://radyabe.ir/api"
    // server_address: "http://10.0.6.23/api"
}

export default conf;
